'use strict';

module.exports = {
  active: 'active',
  inactive: 'inactive',
};
